import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class LogUpdateService {
  public timeoutId: NodeJS.Timeout;
  constructor(private swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      this.checkForUpdate();
    } else {
      console.debug('Service Worker is not enabled yet');
    }
  }

  private checkForUpdate() {
    console.debug('Checking for updates...');
    this.swUpdate.versionUpdates.subscribe(event => {
      console.debug('Version update event:', event);
      if (event.type === 'VERSION_READY') {
        console.debug('A new version is ready to activate.');
        this.setReleaseNoteIndicator();
      }
    });
  }

  private applyUpdate(): void {
    this.swUpdate
      .activateUpdate()
      .then(() => this.reloadApp())
      .catch(error => console.error('Failed to apply updates:', error));
  }

  private reloadApp(): void {
    console.debug('Reloading application...');
    window.location.reload();
  }

  private setReleaseNoteIndicator() {
    localStorage.setItem('newVersion', 'true');
    setTimeout(() => this.applyUpdate(), 100);
  }
}
